import { useEffect, useState } from "react";
import DashboardLayout from '../Layout/Index'
import ComplaintTable from '../components/tables/ComplaintTable'
import { FiSearch } from "react-icons/fi";
import { Select } from '@headlessui/react'
import { fetchComplaints } from "../redux/slices/complaintSlice";
import { useDispatch, useSelector } from "react-redux";
import OpenComplainDrawer from "../Modals/OpenComplainDrawer";
import { SelectDropDown } from "../components/SelectDropdown";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from "@mui/x-date-pickers";

const Complaints = () => {
  const [status, setStatus] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const itemsPerPage = 10;
  
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");

  const [currentPage, setCurrentPage] = useState(1); 
  const [totalRecord, setTotalRecord] = useState(0); 
  const [date, setDate] = useState(null);

  const complaint = useSelector((state) => state.complaint); 

  useEffect(() =>{
    dispatch(
      fetchComplaints({
        status:status,
        date: date,
        searchText: searchTerm,
        pageSize: itemsPerPage,
        pageNumber: currentPage,

    }))
  }, [dispatch, searchTerm, currentPage, date]);

  useEffect(() => {
    if(complaint){
      setTotalRecord(complaint?.complaint?.totalRecord);
    }
  },[complaint]);

  const data = complaint?.complaint?.data;

  const SelectedOption = [
    { label: "Open", value: "1" },
    { label: "In Progress", value: "2" },
    { label: "Reviewed", value: "3" },
  ];

  const handleRowClick = (item) => {
    setSelectedItem(item);
    setIsDrawerOpen(true); 
  };

  const handleSearch = (e) => {
    e.preventDefault()
    setSearchTerm(e.target.value);
  }
  const handleChangeStatus = (selectedOption) => {
    setStatus(selectedOption.value);
  }

  return (
    <DashboardLayout>
      <div className="px-6 sm:px-8 pt-5 py-10 bg-white w-full mt-16">
        <div className="bg-white px-2 py-3">
          <h1 className="text-xl md:text-2xl font-bold text-[#FF0000] pb-2">Customer Feedbacks & Complaints</h1>
          <p className="text-xs md:text-sm text-[#0A0A0ACC]">
            Stay connected to what matters most to our customers. Track feedback and complaints in real time to address issues swiftly, improve service quality, and build stronger relationships with every delivery.
          </p>
        </div>
        <div className="h-[1px] w-full border-0 bg-primaryGray my-4 shadow-md" />
        <div className="flex items-center justify-between px-4 py-6 bg-white shadow-xl">
          <div className="relative">
            <input
              type="search"
              name="search"
              value={searchTerm}
              onChange={handleSearch}
              placeholder="Search"
              className="bg-[#F9F9F9] px-12 py-3 rounded-2xl w-[150px] sm:w-[250] md:w-[350px] ring-0 outline-none text-sm"
            />
            <FiSearch className="absolute left-4 top-3 text-lg text-[#A6A9B9]" />
          </div>
          <div className="flex items-center justify-between gap-5">
            <div className="flex items-center">
              <p className="text-sm font-medium pr-2 font-medium">Review Type </p>
              <SelectDropDown options={SelectedOption} onSelect={handleChangeStatus} 
              />
            </div>
            <div className="flex items-center">
              <p className="text-sm font-medium xl:text-sm pr-2">Date</p>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={date}
                  onChange={(newValue) => setDate(newValue)}
                />
              </LocalizationProvider>
            </div>
        </div>
        </div>
        <ComplaintTable
          onRowClick={handleRowClick} 
          searchTerm={searchTerm} 
          data={data} 
          itemsPerPage={itemsPerPage} 
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          isLoading={complaint?.loading}
          totalRecord={totalRecord}
        />
        <OpenComplainDrawer 
          isOpen={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          id={selectedItem}
        />
      </div>
    </DashboardLayout>
  )
}

export default Complaints